import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.notfound');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-page-notfound',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.notfound/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageNotfoundComponent implements OnInit {

    constructor(@Inject( Service)         public service: Service,@Inject( Title)         private title: Title,@Inject( Router    )         private router: Router    ) {}

    async ngOnInit() {
        await this.service.init();
        this.title.setTitle('404 - 페이지를 찾을 수 없습니다');
        await this.service.render();
    }

    public goHome() {
        this.router.navigateByUrl('/home');
    }
}

export default PageNotfoundComponent;